import { render, staticRenderFns } from "./move.vue?vue&type=template&id=67f9993e"
import script from "./move.vue?vue&type=script&lang=js"
export * from "./move.vue?vue&type=script&lang=js"
import style0 from "./move.vue?vue&type=style&index=0&id=67f9993e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f9993e')) {
      api.createRecord('67f9993e', component.options)
    } else {
      api.reload('67f9993e', component.options)
    }
    module.hot.accept("./move.vue?vue&type=template&id=67f9993e", function () {
      api.rerender('67f9993e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/move.vue"
export default component.exports